//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SEO from '~/mixins/SEO.js'
import JSONSCHEMA from '~/mixins/JSONSCHEMA.js'
export default {
    name: 'index',
    mixins: [SEO,JSONSCHEMA],
    data: () => ({
        // categories: [],
        active: 0,
    }),
    methods: {
        updateActive(index) {
          this.active = index;
        },
    },
    computed:{
      activeFaq(){

        return this.active;
      }
    },
    async asyncData(context) {
  try {
    const [categoryResponse, faqCategoriesResponse] = await Promise.all([
      context.app.$api.fetchCategoryFaq(context.params.slug),
      context.app.$api.fetchFaqsCategories(),
    ]);
    return {
      page: categoryResponse.content,
      categories: faqCategoriesResponse.content,
    };
  } catch (e) {
    context.error({ statusCode: 404 });
  }
},

    mounted() {
        if(this.page.items&&this.page.items.length>0){
            var questions= []
            for(let i=0;i<this.page.items.length;i++){
                var oneQuestion = {
                    "@type": "Question",
                    "name": `${this.page.items[i].title}`,
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": `${this.page.items[i].content}`
                    }
                }
                questions.push(oneQuestion)
            }
            this.$metaInfo.script.find(x=> x.type == 'application/ld+json').json['@graph'].push({
                "@type": "FAQPage",
                "mainEntity": questions
            })
        }
    },

};
